if (typeof TCH === 'undefined') {
  var TCH = {};
}

(function ($) {
  if (typeof TCH.Shoes === 'undefined') {
    TCH.Shoes = {
      /**
       * Shoes initialization.
       */
      Init: function () {
        var productDeliveryInfo = document.getElementById ('product-delivery-info');
        if (productDeliveryInfo !== null) {
          this.Product.DeliveryInfo (productDeliveryInfo);
        }
      },
      
      Product: {
        days: [
          'v pondelok',
          'v utorok',
          'v stredu',
          'vo štvrtok',
          'v piatok',
          'v sobotu',
          'v nedeľu'
        ],
        
        /**
         * Calculate delivery info for product.
         */
        DeliveryInfo: function (container) {
          this.GetHolidays (function (holidays) {
            var now = moment ();
            
			now = TCH.Shoes.Product.HolidayToNot (holidays, now);
            
            var dayOfWeek = parseInt (now.format ('d'));
            var hour = parseInt (now.format ('H'));
            
            if (dayOfWeek < 5) {
              if (hour < 12) {
                now.add (1, 'days');
              } else {
                if (dayOfWeek < 4) {
                  now.add (2, 'days');
                } else {
                  now.add (4, 'days');
                }
              }
            } else {
              now.add (4, 'days');
            }
            
            now = TCH.Shoes.Product.HolidayToNot (holidays, now);
            
            var courierInfo = 'U vás doma ' + TCH.Shoes.Product.days [parseInt (now.format ('d')) - 1];
            courierInfo += ' (' + now.format ('D.M.') + ')';
            
            now = moment ();
            
			now = TCH.Shoes.Product.HolidayToNot (holidays, now);
            
            dayOfWeek = parseInt (now.format ('d'));
            hour = parseInt (now.format ('H'));
            if (hour >= 12) {
              now.add (1, 'days');
            }
            
            nextDeliveryDay = null;
            if (dayOfWeek === 1) {
              now.day (2);
            } else if (dayOfWeek > 4) {
              now.add (1, 'weeks').day (2);
            } else {
              now.day (5);
            }
            
            var siteInfo = 'Na výdajnom mieste ' + TCH.Shoes.Product.days [parseInt (now.format ('d')) - 1];
            siteInfo += ' (' + now.format ('D.M.') + ')';
            
            var tooltip = '<p><strong>Kuriér:</strong> ' + courierInfo + '</p>';
            tooltip += '<p><strong>Zásielkovňa:</strong> ' + siteInfo + '</p>';
            
            document.getElementById ('product-delivery-info-courier').innerHTML = courierInfo;
			document.getElementById ('product-delivery-info-tooltip').innerHTML = tooltip;
            
            container.querySelector ('button').addEventListener ('click', function () {
              $ (container).toggleClass ('open');
            });
            document.body.addEventListener ('click', function (e) {
              if (container.classList.contains ('open')) {
                var target = $ (e.target);
                
                if (!target.is ('#product-delivery-info') && target.parents ('#product-delivery-info').length === 0) {
                  container.classList.remove ('open');
                }
              }
            });
          });
        },
        
        /**
         * Get holidays from localStorage or from API.
         */
        GetHolidays: function (callback) {
          var holidays = localStorage.getItem ('holidays');
          
          if (holidays !== null) {
            callback (JSON.parse (holidays));
            return;
          }
          
          var year = moment ().format ('YYYY');
          
          var ajax = new XMLHttpRequest ();
          ajax.addEventListener ('load', function () {
            let data = JSON.parse (ajax.responseText);
            
            if (typeof data === 'object' && typeof data.response === 'object' && typeof data.response.holidays === 'object') {
              localStorage.setItem ('holidays', JSON.stringify (data.response.holidays));
              
              callback (data.response.holidays);
              return;
            }
            
            callback (null);
          });
          ajax.addEventListener ('error', function () {
            console.error (ajax);
            
            callback (null);
          });
          ajax.open ('GET', 'https://calendarific.com/api/v2/holidays?api_key=01ebdba78d022d7b188b33602a6405324288d6fc&country=SK&year=' + year);
          ajax.send ();
        },
        
        /**
         * If date is holiday, then find nearest not holiday.
         */
        HolidayToNot: function (holidays, date) {
          if (typeof holidays !== 'object') {
            return date;
          }
          
          var pureHolidays = holidays;
          
          holidays = holidays.filter (function (element) {
            for (var i = 0; i < element.type.length; i++) {
              if (element.type [i] === 'National holiday') {
                return true;
              }
            }
            
            return false;
          });
          holidays = holidays.map (function (element) {
            return element.date.iso;
          });
          
          var theDate = date.format ('YYYY-MM-DD');
          if (holidays.includes (theDate)) {
            date.add (1, 'days');
            
            date = TCH.Shoes.Product.HolidayToNot (pureHolidays, date);
          }
          
          return date;
        }
      }
    };
    
    $ (function () {
      TCH.Shoes.Init ();
    });
  }
}) (jQuery);

if (typeof (JG) === 'undefined') {
	var JG = {};
}

(function ($) {
  	JG.Shoes = {
      Init: function () {
        let self = this;
        this.popup.Init ();

        if (jQuery('#thumbs_list').length > 0){
          jQuery(window).on('load', function(){
          	self.SetThumbSliderHeight();
          })
        }
        
        if (jQuery('#AddToCartForm').length > 0){
          jQuery(window).on('load', function(){
          	self.EditProductVariants();
          })
        }
        
        if (jQuery('.productMobileSlider').length > 0 && window.matchMedia ('(max-width: 991px)').matches){
        	self.InitProductMobileSlider();
        }
        
        jQuery('body').on('click','.openLightbox', function(e){
        	self.OpenLighBox(e);
        })
        
        jQuery('body').on('click','.cooki-container a:last-child', function(){
			self.DenyCookies();
        })
        
		jQuery('body').on('click','.sizePickerButton', function(){
			self.ChangeProductSize(this);
        })
        
        if (jQuery('.scrollTable').length > 0){
          jQuery(window).on('load', function(){
          	self.TablesXScroll();
          })
        }
        
        jQuery('body').on('click','#page', function(e){
          self.CloseMobileMenu(e);
        })
        
		if (jQuery('.productDetailNotice').length > 0){
          jQuery(window).on('load', function(){
            self.ShowNotice();
          })
        }        
      },
      
      ShowNotice: function(){
      	let rnd = Math.floor((Math.random() * 10) + 1);
        if (rnd > 8) {
        	jQuery('.productDetailNotice.first').fadeIn()	
        } else {
        	jQuery('.productDetailNotice.second').fadeIn()
        }
      },
      
      CloseMobileMenu: function(e){
        if (jQuery('.apollo-megamenu.active').length > 0){
        	let target = jQuery(e.target);
          if (target.attr('id') === 'page'){
            jQuery('#off-canvas-button .off-canvas-nav').click();
          }
        }
      },
      
      TablesXScroll: function(){
      	let tables = jQuery('.scrollTable');
        tables.each(function(){
          let thisTable = jQuery(this); 
          thisTable.wrap('<div class="scrollTableWrapper" style="overflow-x: auto;"></div>');
          jQuery('.scrollTableWrapper').prepend('<span class="scrollRightLabel">Posuňte doľava <i class="fa fa-arrow-right" aria-hidden="true"></i></span>');
        })
      },
      
      DenyCookies: function(){
      	let cookieContainer = jQuery('.cooki-container');
        if (cookieContainer.css('top') === '0px' ){
        	jQuery('.cooki-decline')[0].click();
        }
      },
      
      OpenLighBox: function(e){
        e.preventDefault();
        let images = jQuery('.openLightbox')
        let gallerylist = [];
        images.each(function(){
          gallerylist.push({
            href: jQuery(this).data('image'),
            title: jQuery(this).attr('title')
          });
        })
        jQuery.fancybox(gallerylist,{prevEffect	: 'none', nextEffect : 'none', maxWidth	: 800,
		maxHeight	: 800,
		fitToView	: true,
		width		: '90%',
		height		: '90%',
		autoSize	: false, });
      },
      
      /*mobile product slider*/
      InitProductMobileSlider: function(){
      	jQuery('.productMobileSlider').owlCarousel({
          navigation : true,
          paginationSpeed : 400,
          singleItem : true,
          navigationText: ["",""],
          pagination: false,
          touchDrag  : true,
     	  mouseDrag  : true
          });
      },
      
      /*change product size*/
      ChangeProductSize: function(button){
      	let btn = jQuery(button);
        let container = btn.closest('.sizeButtons');
        container.find('.sizePickerButton').removeClass('active');
        let select = jQuery('#'+btn.data('select_id'));
        select.val(btn.data('size_value')).change();
        btn.addClass('active');
      },
      
      /* replace selects with text and buttons*/
      EditProductVariants: function(){
      	let wrappers = jQuery('#AddToCartForm').find('.selector-wrapper');
        for (let i = 0; i < wrappers.length; i++){
          let singleWrapper = jQuery(wrappers[i]);
          let labelText = singleWrapper.find('label').text(); 
          if (labelText != 'Veľkosť'){
            if ( window.matchMedia('(max-width: 600px)').matches ){
            	jQuery('.appendLabelsOnMobile').append('<div class="variantInner"><label>'+labelText+':</label><span>'+singleWrapper.find('select option:first-child').val()+'</span></div>')
            }else{
            	jQuery('#AddToCartForm').prepend('<div class="variantInner"><label>'+labelText+':</label><span>'+singleWrapper.find('select option:first-child').val()+'</span></div>')
            }
          } else {
            
            
            /*
            if ( window.matchMedia('(max-width: 991px)').matches ){
              	let label = singleWrapper.find('label');
              	label.show();
                label.text(label.text()+':');
            	singleWrapper.find('select').show();
            } else {
              let select = singleWrapper.find('select');
              let id = select.attr('id');
              singleWrapper.addClass('sizesWrapper');
              singleWrapper.append('<div class="sizeButtons"><label class="showThisOne">Veľkosť:</label></div>');
              let btnsContainer = singleWrapper.find('.sizeButtons');
              let selectedValue = select.val();
              select.find('option').each(function(){
               let val = jQuery(this).val();
               let active = '';
                if (val === selectedValue){ 
                	active = ' active';
                }
               btnsContainer.append('<button class="sizePickerButton'+active+'" type="button" data-size_value="'+val+'" data-select_id="'+id+'">'+val+'</button>')
              }) 
            }
            */
            
              let select = singleWrapper.find('select');
              let id = select.attr('id');
              singleWrapper.addClass('sizesWrapper');
              singleWrapper.append('<div class="sizeButtons"><label class="showThisOne">Veľkosť:</label></div>');
              let btnsContainer = singleWrapper.find('.sizeButtons');
              let selectedValue = select.val();
              select.find('option').each(function(){
               let val = jQuery(this).val();
               let active = '';
                if (val === selectedValue){ 
                	active = ' active';
                }
               btnsContainer.append('<button class="sizePickerButton'+active+'" type="button" data-size_value="'+val+'" data-select_id="'+id+'">'+val+'</button>')
              }) 
            
          }
        }
      },
      
      /*adjust size of tuhmbnails container*/
      SetThumbSliderHeight: function(){
        let slider = jQuery('#thumbs_list');
      	let items = slider.find('.thumb_item');
        if (items.length >= 3){
          let height = 0;
          for (let i = 0; i < 3; i++ ){        	
        	height += jQuery(items[i]).outerHeight(true);
          }
          slider.height(Math.floor(height)-1);
        }
      },
      
      popup: {
	      
			Init: function () {
				let self = this;
				let body = $ ('body');

				body.on ('click', '.openSizesPopup', function (e) {
					let thiss = $ (this);
					self.ShowPopup (e, 'sizesPopup');
				});


				jQuery ('body').on ('click', '.closePopup', function (e) {
					self.HidePopup (e);
				});

				jQuery ('body').on ('click', '.popup', function (e) {
					if (jQuery(e.target).hasClass('popupouter')){
					self.HidePopup (e);
					}
				});

				jQuery(document).keyup(function(e) {
	     		if (e.keyCode == 27) {
	        		self.HidePopup (e);
	    			}
				});
	        },

			/**
			 * Show popup.
			 */
			ShowPopup: function (e, selector) {
				let self = this;
				if (e != null) {
					e.preventDefault ();
				}

				let body = jQuery ('body');
				let jDocument = jQuery (document);
				body.css ('top', '-'+jDocument.scrollTop ()+'px').data ('top', jDocument.scrollTop ());
				body.addClass ('noScroll');
				jDocument.scrollTop (0);

				selector = typeof (selector) != 'undefined' ? selector : 'popup';

				jQuery ('.'+selector+'-shadow, .'+selector).css ('display', 'flex');

	            jQuery ('.'+selector).css ('opacity', 0).animate ({opacity: 1}, 500);
			},



			/**
			 * Hide popup.
			 */
			HidePopup: function (e, selector) {
				if (e != null) {
					e.preventDefault ();
				}
				let body = jQuery ('body');
				let jDocument = jQuery (document);
				body.removeClass ('noScroll');
				let scroll = Math.abs (parseFloat (body.data ('top')));
				jDocument.scrollTop (scroll);

				selector = typeof (selector) != 'undefined' ? selector : 'popup';

				jQuery ('.'+selector).animate ({opacity: 0}, 500, function () {
					jQuery ('.'+selector+'-shadow, .'+selector).hide ();
				});
			}
    	},
      
      
    };
}) (jQuery);

jQuery (function () {
	JG.Shoes.Init ();
});